module.exports = __webpack_public_path__ + "static/media/SE.97de883d.svg";